import { render, staticRenderFns } from "./ProviderListPage.vue?vue&type=template&id=1eb34412&"
import script from "./ProviderListPage.vue?vue&type=script&lang=js&"
export * from "./ProviderListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports